import { render } from "./Season2Icon.vue?vue&type=template&id=33a4093b"
import script from "./Season2Icon.vue?vue&type=script&lang=js"
export * from "./Season2Icon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__